import { MissionType } from "@/types";
import { toast } from "sonner";
import { useMapLibre, useSite } from "@/hooks";
import { useAtom } from "jotai";
import { missionAtom } from "@/store";
import { LngLat, LngLatBoundsLike } from "maplibre-gl";
import { useTranslations } from "next-intl";
import { feature, bbox } from "@turf/turf";

export const useMission = () => {
  const t = useTranslations("mission.MissionToast");
  const [mission, setMission] = useAtom(missionAtom);
  const { resetSite } = useSite();
  const { flyTo, fitBounds } = useMapLibre();

  const cancelMission = () => {
    setMission(null);
  };

  const locateMission = (mission: MissionType) => {
    setMission(mission);
    resetSite();

    const bounds = getBounds(mission);
    const position = getPosition(mission);

    if (bounds) {
      fitBounds(bounds);
    } else if (position) {
      flyTo(position);
    } else {
      toast(t("title"), {
        description: t("description"),
      });
    }
  };

  const getPosition = (mission: MissionType) => {
    if (mission.latitude && mission.longitude) {
      return new LngLat(mission.longitude, mission.latitude);
    }

    return undefined;
  };

  const getBounds = (mission: MissionType) => {
    return bbox(feature(mission.geometry)) as LngLatBoundsLike;
  };

  return { mission, setMission, cancelMission, locateMission };
};
